import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { PinchZoomComponent} from '@meddv/ngx-pinch-zoom';

@Component({
    selector: 'mbnm-pinch-zoom-wrapper',
    templateUrl: './pinch-zoom-wrapper.component.html',
    styleUrls: ['./pinch-zoom-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PinchZoomComponent],
})
export class PinchZoomWrapperComponent implements OnInit {

  @Input() content;
  constructor() { }

  ngOnInit() {
  }

}
